import { createSlice, createAction } from '@reduxjs/toolkit';
import initialState from '../../../domain/entities/paymentButton';

function generatePaymentButtonSuccess(state, action) {
  const { code, message, token, url } = action.payload;

  state.generatePaymentButton = {
    success: true,
    error: false,
    code,
    message,
    token,
    url,
  };
}

function generatePaymentButtonError(state, action) {
  const { code, message } = action.payload;
  state.generatePaymentButton = {
    success: false,
    error: true,
    code,
    message,
  };
}

function confirmPaymentButtonSuccess(state, action) {
  const { code, message, paymentTypeCode: paymentType , authorizationCode, cardNumber, transactionDate } = action.payload;
  state.confirmPaymentButton = {
    success: true,
    error: false,
    code,
    message,
    paymentType,
    authorizationCode,
    cardNumber,
    transactionDate
  };
}

function confirmPaymentButtonError(state, action) {
  const { code, message } = action.payload;
  state.confirmPaymentButton = {
    success: false,
    error: true,
    code,
    message,
  };
}

const generatePaymentButton = createAction('generatePaymentButton');
const confirmPaymentButton = createAction('confirmPaymentButton');

const paymentButtonReducer = createSlice({
  name: 'paymentButton',
  initialState,
  reducers: {
    generatePaymentButtonSuccess,
    generatePaymentButtonError,
    confirmPaymentButtonSuccess,
    confirmPaymentButtonError,
  },
});

export const paymentButtonActions = {
  ...paymentButtonReducer.actions,
  generatePaymentButton,
  confirmPaymentButton,
};

export default paymentButtonReducer.reducer;
